import { newsArchivesDisplaying, selectValues, newsArchives } from './newsSearch.js';



(function(){

  // 変更を監視するノードを選択
  const targetNode = newsArchivesDisplaying;
  if (!targetNode) return;

  // (変更を監視する) オブザーバーのオプション
  const config = {
    attributes: true,
    childList: true,
    subtree: true
  };

  // 変更が発見されたときに実行されるコールバック関数
  const callback = (mutationsList, observer) => {
    // ページネーションのボタン
    const btn = document.querySelectorAll('.pager');

    // ないときは何もしません
    if( btn.length <= 0 ) return;

    for( let b of btn ){
      b.onclick = (e) => {
        // value を取得
        const values = selectValues();

        // ページ数を追加
        values.page = e.currentTarget.dataset.page;

        // 表示する要素のスクロールトップを取得
        const rect      = newsArchivesDisplaying.closest('article').getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        // header の高さ
        const headerHeight = document.querySelector('header').offsetHeight;

        // 結果を表示します
        newsArchives(values);

        // 表示する要素までスクロールします
        window.scrollTo({
          top: rect.top - scrollTop - headerHeight,
          left: 0,
          behavior: 'smooth'
        });
      }
    }
  };

  // コールバック関数に結びつけられたオブザーバーのインスタンスを生成
  const observer = new MutationObserver(callback);

  // 対象ノードの設定された変更の監視を開始
  observer.observe(targetNode, config);

}());
